import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import './fatturazione.scss';
import {FatturazioneComponent} from './fatturazione';
import {
  RequestInformationFatturaPaModule
} from './request-information-fattura-pa/request-information-fattura-pa.module';
import {
  RequestInformationFatturaPaLpModule
} from './request-information-fattura-pa-lp/request-information-fattura-pa-lp.module';
import {FatturazionePAModule} from './fatturazione-pa/fatturazione-pa.module';
import {FatturazionePRModule} from './fatturazione-pr/fatturazione-pr.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.fatturazione', {
      url: '/fatturazione',
      ncyBreadcrumb: {
        label: 'Fatturazione',
        parent: 'home.home-index'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Fatturazione'
      },
      views: {
        homeContent: {
          template: '<fatturazione flex="100"></fatturazione>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const FatturazioneModule: string = ng
  .module('fatturazione', [
    'ui.bootstrap',
    uiRouter,
    RequestInformationFatturaPaModule,
    RequestInformationFatturaPaLpModule,
    FatturazionePAModule,
    FatturazionePRModule
  ])
  .component('fatturazione', FatturazioneComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione.module.ts